﻿$.fn.dxCtrlMenuEmail = function custom_dxCtrlMenuEmail(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlmenuemail dx-ctrl");
        this.createInstance(new cdxCtrlMenuEmail(this, option));
    }
    return this;
}

window.cdxCtrlMenuEmail = function (container, option) {
    var Me = this;


    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }
    if (typeof option.context_grid == 'undefined') option.context_grid = "grid_email_avec_classeur"
    if (typeof option.dataUti == 'undefined') option.dataUti = option.bddCtrl.utiCourant

    //option.bddCtrl.mAddFunctionOnModifiedItemData(["compte_email", "compte_email_utilisateur", "utilisateur", "compte_client"], container, function (action, itemData) {
    //    option.bddCtrl.mReloadTable("compte_email", function () {
    //        dxAccord.option("dataSource", Me.mGetDs())
    //    })
    //})
    option.bddCtrl.mAddFunctionOnModifiedItemData(["compte_email", "compte_email_utilisateur", "utilisateur"], container, function (action, itemData) {
        option.bddCtrl.mReloadTable("compte_email", function () {
            dxAccord.option("dataSource", Me.mGetDs())
        })
    })

    var $DivLoad = null
    var dxAccord = null;
    var lstItemElement = {}
    var txtSearchClasseur = "";
    function mConstruit() {
        container.empty();
        container.css("position", "relative")
        //container.css("height", "100%")

        var firstLoad = true
        var ds = Me.mGetDs()
        inload = true;
        var dxScroll = $("<div/>").appendTo(container).dxScrollView({}).dxScrollView("instance")
        var currentSelectedItem = null
        dxAccord = $("<div class='dx-accordion-hide-chevron dx-accordion-sans_padding' style='margin:0;'/>").appendTo(dxScroll.content()).dxAccordion({
            dataSource: Me.mGetDs(),
            selectedItems: selectedItem,
            width: "100%",
            collapsible: option.collapsible,
            //collapsible: false,
            multiple: false,
            itemTitleTemplate: function (itemData, itemIndex, itemElement) {
                itemElement.parent().css("border", "none")
                itemElement.css({
                    "padding": "6px 6px 6px 6px",
                    "border-top": theme.border,
                    "border-bottom": theme.border
                })
                if (itemData.adresse_email == "Favori") {
                    var $Table = $("<table style='width:100%;table-layout:fixed;'/>").appendTo(itemElement)
                    var $Tr = $("<tr/>").appendTo($Table)
                    var $Td = $("<td style='width:0px'/>").appendTo($Tr)
                    var $Td = $("<td style='width:100%;overflow: hidden;text-overflow: ellipsis;position:relative;font-size:140%;'/>").appendTo($Tr)
                    var nbFavori = option.bddCtrl.mGetArray("compte_email_utilisateur").filter(function (o) { return o.in_favori == "1" && o.id_utilisateur == option.dataUti.id_utilisateur }).length
                    var txt = "⭐Favori"
                    if (nbFavori > 1) txt += "s"
                    txt += "<sup style='font-size:70%;'>(" + nbFavori + ")</sup>"
                    $Td.html(txt)

                    var $DivCompteur = $("<div style='padding:2px 4px 2px 3px;font-family:barlow condensed;position:absolute;top:0;right:0;font-size:60%;background-color:" + theme.backgroundColorCompteur + ";border-radius:5px;font-weight:500;display:none;color:" + theme.backgroundcolorTooltip + ";' class='count'></div>").appendTo($Td)
                    //var $DivCompteur = $("<div style='border-radius:5px;background-color:" + theme.backgroundcolorTooltip + ";opacity:1;position:absolute;display:none;min-width:18px;top:0;right:0;' class='dx-theme-accent-as-text-color'><div style='border-radius:10px;1px 3px 1px 2pxfont-weight:500;background-color:" + theme.backgroundcolorTooltip + ";font-size:60%;font-family:barlow condensed;opacity:0.8;line-height:100%;text-align:center;'></div></div>").appendTo($Td)
                    var nb = 0
                    mUpdateCompteur()
                    function mUpdateCompteur() {
                        if ($DivCompteur.closest("body").length == 0) return
                        nbRecu = option.bddCtrl.msgEmailSms.mGetNbEmail([1], "favori", "1")
                        nbErreur = option.bddCtrl.msgEmailSms.mGetDsEmailErreur("favori", false).nb
                        var val = option.bddCtrl.msgEmailSms.mGetHtmlEtTooltipForEmailNb(nbRecu, nbErreur)
                        if (val.html.length > 0) {
                            $DivCompteur.attr("title", val.title)
                            $DivCompteur.html(val.html)
                            $DivCompteur.css("display", "")
                        } else {
                            $DivCompteur.css("display", "none")
                        }
                    }
                    $(window).on("changeNbEmail", function (e) { if (itemElement.closest("body").length > 0) mUpdateCompteur() });
                    var $Td = $("<td style='width:36px'/>").appendTo($Tr)
                    $("<div style='display:inline-block;'/>").appendTo($Td).dxCtrlButton({
                        icon: "fas fa-plus-minus",
                        txtTooltip: "Gérer les adresses emails en favori",
                        height: 36,
                        width: 36,
                        onClick: function (e) {
                            e.event.preventDefault()
                            e.event.stopPropagation()
                            var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
                                target: e.component.element(),
                                width: 350,
                                contentTemplate: function (contentElement) {
                                    contentElement.css("padding", "15px")
                                    contentElement.css("text-align", "left")
                                    var lstEmailUti = option.bddCtrl.mGetArray("compte_email_utilisateur").filter(function (oo) { return oo.id_utilisateur == option.dataUti.id_utilisateur }).sort(function (o1, o2) { o1.in_favori != o2.in_favori })
                                    var dxList = $("<div/>").appendTo(contentElement).dxList({
                                        dataSource: new DevExpress.data.DataSource({
                                            store: lstEmailUti,
                                            //group: { selector: "in_favori", desc: true }
                                        }),
                                        noDataText: "(Aucune adresse email)",
                                        focusStateEnabled: false,
                                        grouped: false,
                                        collapsibleGroups: true,
                                        selectionMode: "single",
                                        groupTemplate: function (itemData, itemIndex, itemElement) {
                                            itemElement.text(((itemData.key == "1") ? "Dans les favoris" : "Hors favoris"))
                                        },
                                        itemTemplate: function (itemData, itemIndex, itemElement) {
                                            itemElement.css("opacity", ((itemData.in_favori == "1") ? 1 : 0.5))
                                            var dataCpteEmail = option.bddCtrl.mGetArray("compte_email").filter(function (o) { return o.id_compte_email == itemData.id_compte_email })[0]
                                            var $Table = $("<table style='width:100%'/>").appendTo(itemElement)
                                            var $Tr = $("<tr/>").appendTo($Table)
                                            var $Td = $("<td style='width:100%;'>" + dataCpteEmail.adresse_email + "</td>").appendTo($Tr)
                                            var $Td = $("<td style='width:1px;'/>").appendTo($Tr)
                                            $("<div style='display:inline-block;'/>").appendTo($Td).dxCtrlButton({
                                                icon: ((itemData.in_favori == "1") ? "fas fa-minus" : "fas fa-plus"),
                                                txtTooltip: ((itemData.in_favori == "1") ? "Enlever des favoris" : "Rajouter aux favoris"),
                                                height: 36,
                                                width: 36,
                                                onClick: function (e) {
                                                    e.event.preventDefault()
                                                    e.event.stopPropagation()
                                                    itemData.in_favori = ((itemData.in_favori == "1") ? "0" : "1")
                                                    option.bddCtrl.getObjet(itemData).mSave()
                                                    mNotify("L'adresse email <u>" + dataCpteEmail.adresse_email + "</u> a été " + ((itemData.in_favori == "1") ? "rajoutée au favori" : "retirée des favoris"), "success", 6000)
                                                    tt.hide()
                                                }
                                            })
                                        }
                                    })
                                }
                            }).dxCtrlTooltip("instance");
                            tt.show();
                        }
                    })
                } else if (itemData.adresse_email == "Mailing email") { //ancien pour emailing
                    itemElement.css("display", "none")
                } else {
                    var $Table = option.bddCtrl.getObjet(itemData).objetMetier.templateTitleEmail(itemElement, option.bddCtrl.utiCourant.id_utilisateur)
                    var $TrJauge = $("<tr style=''/>").appendTo($Table)
                    var $TdJauge = $("<td></td>").appendTo($TrJauge)
                    $("<div/>").appendTo($TdJauge).dxCtrlSuiviTraitementEmailServeurReception({
                        bddCtrl: option.bddCtrl,
                        container: $TrJauge,
                        dataCompteEmail: itemData
                    })
                }
            },
            itemTemplate: function (itemData, itemIndex, itemElement) {
                itemElement.css("padding", "0")
                //itemData.itemElement = itemElement
                lstItemElement[itemData.adresse_email] = itemElement
                if (firstLoad) {
                    firstLoad = false
                    window.setTimeout(function () { mSelectChangeAccordion() }, 0)
                }
            },
            onSelectionChanged: function (e) {
                mSelectChangeAccordion()
            },
            onContentReady: function (e) {
                inLoad = false;
            }
        }).dxAccordion("instance")

        function mSelectChangeAccordion() {
            if (currentSelectedItem != null) {
                lstItemElement[currentSelectedItem.adresse_email].empty()
            }
            currentSelectedItem = dxAccord.option("selectedItem")
            if (typeof currentSelectedItem == 'undefined' || currentSelectedItem == null) {
                //on a tout fermé les items
                option.bddCtrl.utiCourantParaJson[option.context_grid].lastSelectedItem = null
                option.bddCtrl.mSaveParaJsonUtilisateur();
                Me.mSelect(null, null, null, null)
            } else {
                var newItemElement = lstItemElement[currentSelectedItem.adresse_email]
                newItemElement.empty()
                currentSelectedItem.dx = $("<div/>").appendTo(newItemElement).dxCtrlTreeViewEmail({
                    bddCtrl: option.bddCtrl,
                    dxScrollParent: dxScroll,
                    itemData: currentSelectedItem,
                    txtSearchClasseur: txtSearchClasseur,
                    id_type_classement: ((typeof option.optionMenu != 'undefined') ? option.optionMenu.id_type_classement : null),
                    context_grid: option.context_grid,
                    onChangeTexteSearchClasseur: function (txt) {
                        txtSearchClasseur = txt
                    },
                    onChange: function (itemData, itemDataMenu) {
                        Me.mSelect(itemData, itemDataMenu, itemDataMenu.idTypeCom, itemDataMenu.lstIdTypeClassement)
                    }
                }).dxCtrlTreeViewEmail("instance")
                delete option.optionMenu
                if (option.bddCtrl.utiCourantParaJson[option.context_grid].lastSelectedItem == null ||
                    option.bddCtrl.utiCourantParaJson[option.context_grid].lastSelectedItem.adresse_email != currentSelectedItem.adresse_email) {
                    option.bddCtrl.utiCourantParaJson[option.context_grid].lastSelectedItem = ((dxAccord.option("selectedItems").contains(currentSelectedItem)) ? currentSelectedItem : null)
                    option.bddCtrl.utiCourantParaJson[option.context_grid].selectedItem = [currentSelectedItem]
                    console.log(option.bddCtrl.utiCourantParaJson[option.context_grid].lastSelectedItem)
                    console.log(option.bddCtrl.utiCourantParaJson[option.context_grid].selectedItem)
                    option.bddCtrl.mSaveParaJsonUtilisateur();
                    if (typeof currentSelectedItem.dx != 'undefined') {
                        var itemDataMenu = currentSelectedItem.dx.mGetItemDataMenu()
                        Me.mSelect(currentSelectedItem, itemDataMenu, itemDataMenu.idTypeCom, itemDataMenu.lstIdTypeClassement)
                    }
                }
            }
        }

        $DivLoad = $("<div style='position:absolute;bottom:0;width:100%;'/>").appendTo(container)
        resizeObserver.mAdd($DivLoad, function () {
            dxScroll.element().css("height", "calc(100% - " + $DivLoad.innerHeight() + "px)")
        })

    }

    var selectedItem = []
    this.mGetDs = function () {
        var ds = []
        if (option.forEmailing) {
            ds.push({ adresse_email: "Mailing email" })
        } else {
            ds.push({ adresse_email: "Favori" })
            option.bddCtrl.getObjet(option.bddCtrl.utiCourant).objetMetier.mGetLstDataCompteEmail().forEach(function (itemData) {
                ds.push(itemData)
            })
        }

        selectedItem = []
        if (typeof option.optionMenu != 'undefined') {
            selectedItem = ds.filter(function (o) { return o.adresse_email == option.optionMenu.adresse_email })
        } else {
            if (typeof option.bddCtrl.utiCourantParaJson[option.context_grid] == 'undefined') option.bddCtrl.utiCourantParaJson[option.context_grid] = {}
            if (typeof option.bddCtrl.utiCourantParaJson[option.context_grid].selectedItem == 'undefined' ||
                option.bddCtrl.utiCourantParaJson[option.context_grid].selectedItem == null) {
                option.bddCtrl.utiCourantParaJson[option.context_grid].selectedItem = [ds[0]]
                selectedItem = [ds[0]]
            } else {
                //option.bddCtrl.utiCourantParaJson[option.context_grid].selectedItem.forEach(function (item) {
                var itemSelect = ds.filter(function (o) {
                    if (typeof option.bddCtrl.utiCourantParaJson[option.context_grid].selectedItem.length == 'undefined') {
                        //on a pas un tableau
                        return option.bddCtrl.utiCourantParaJson[option.context_grid].selectedItem.adresse_email == o.adresse_email
                    } else {
                        return option.bddCtrl.utiCourantParaJson[option.context_grid].selectedItem[0].adresse_email == o.adresse_email
                    }
                })[0]
                if (typeof itemSelect != 'undefined') selectedItem.push(itemSelect)
                //})
            }
        }
        return ds
    }

    var timeOutSelect = null
    var inLoad = false
    this.mSelect = function (itemDataCompteEmail, itemDataMenu, idTypeCom, lstIdTypeClassement) {
        if (inLoad) return
        window.clearTimeout(timeOutSelect)
        timeOutSelect = window.setTimeout(function () {
            if (typeof option.onSelectionChanged != 'undefined') option.onSelectionChanged(itemDataCompteEmail, itemDataMenu, idTypeCom, lstIdTypeClassement)
        }, 50)
    }

    this.element = function () { return container }

    mConstruit();
}